import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import YodaProductCartridge from 'yoda-site-components/lib/components/YodaProductCartridge/YodaProductCartridge';
import {
    getProductListFromCriteo,
    mergeSponsoredAndORganicProducts,
} from '../../actions/CriteoActions';
import { getCriteoPageID, getProductsPerPage } from '../../utils';
import { getListItemsPerRow } from '../../helpers/GalleryHelper';
import getBreadCrumbInfo from '../../selectors/BreadCrumbs';
import { getH1Tag } from '../../selectors/SeoTags';

/* istanbul ignore next */
export class CriteoZone extends React.PureComponent {
    static defaultProps = {
        page: 'search',
        h1Tag: '',
        breadCrumbInfo: [],
        selectedFilters: [],
        pagination: {},
        products: [],
        sortOptions: [],
        actions: {},
        criteoProducts: null,
        deviceType: {
            isDesktop: false,
            isMobile: true,
            isTablet: false,
        },
        preferences: {},
    };

    static propTypes = {
        page: PropTypes.string,
        h1Tag: PropTypes.string,
        breadCrumbInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedFilters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pagination: PropTypes.oneOfType([PropTypes.object]),
        products: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        criteoProducts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        sortOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.objectOf(PropTypes.bool),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        featureFlags: PropTypes.objectOf(PropTypes.bool).isRequired,
    };

    constructor(props) {
        super(props);
        this.triggered = false;
        this.state = {
            breadCrumbInfo: props.breadCrumbInfo,
            h1Tag: props.h1Tag,
            selectedFilters: props.selectedFilters,
            pagination: props.pagination,
            products: props.products,
            sortOptions: props.sortOptions,
            // criteoProducts: null,
        };
    }

    componentDidMount() {
        this.getCriteoZones();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            products: previousProducts,
            criteoProducts: prevCriteoProds,
            deviceType,
        } = this.props;
        const { products: newProducts, criteoProducts: newCriteoProds } = nextProps;
        if (previousProducts !== newProducts) {
            this.setState(
                {
                    breadCrumbInfo: nextProps.breadCrumbInfo,
                    h1Tag: nextProps.h1Tag,
                    selectedFilters: nextProps.selectedFilters,
                    pagination: nextProps.pagination,
                    products: nextProps.products,
                    sortOptions: nextProps.sortOptions,
                    // criteoProducts: null,
                },
                () => {
                    this.getCriteoZones();
                }
            );
        } else if (prevCriteoProds !== newCriteoProds) {
            // this.setState({ criteoProducts: newCriteoProds });
            this.props.actions.mergeSponsoredAndORganicProducts({
                itemsPerRow: getListItemsPerRow(deviceType),
            });
        }
    }

    getCriteoZones = () => {
        const { page, deviceType } = this.props;
        const path = this.getPathName(page);
        const products = this.getOrganicProducts();
        this.props.actions.getProductListFromCriteo({ path, deviceType, products });
    };

    getKeyword() {
        const { h1Tag } = this.state;
        if (h1Tag) {
            return encodeURIComponent(h1Tag);
        }
        return '';
    }

    getCategory() {
        const { breadCrumbInfo } = this.state;
        let crumbs = '';
        breadCrumbInfo.forEach((key, ind) => {
            if (ind === breadCrumbInfo.length - 1) {
                crumbs += `${key.breadCrumbLabel}`;
            } else {
                crumbs += `${key.breadCrumbLabel}>`;
            }
        });
        return encodeURIComponent(crumbs);
    }

    getFilters() {
        const { selectedFilters } = this.state;
        const {
            featureFlags: { getClearanceSponsoredProducts },
        } = this.props;
        const batch = {};
        let filters = `(clearance,eq,${getClearanceSponsoredProducts || false}),`;
        let prange = false;
        let min = 999999999999999;
        let max = 0;
        selectedFilters.forEach((category) =>
            category.facetValueList.forEach((facet) => {
                if (facet.selected === true) {
                    if (category.facetType === 'prange') {
                        if (min > parseFloat(facet.minRangeValue)) {
                            min = parseFloat(facet.minRangeValue);
                            prange = true;
                        }
                        if (max < parseFloat(facet.maxRangeValue)) {
                            max = parseFloat(facet.maxRangeValue);
                            prange = true;
                        }
                    } else if (category.facetName !== 'View All') {
                        batch[category.facetName] =
                            (batch[category.facetName] ? `${batch[category.facetName]},` : '') +
                            facet.name;
                    }
                }
            })
        );

        Object.keys(batch).forEach((key) => {
            filters += `(${key},eq,${batch[key]}),`;
        });

        if (prange) {
            filters += `(min,ge,${min}),`;
            filters += `(max,le,${max}),`;
        }
        return filters.slice(0, -1);
    }

    getPageNum() {
        const { pagination } = this.state;
        return pagination ? pagination.selectedPageNumber || 1 : 1;
    }

    getOrganicSkus() {
        const { products } = this.state;
        let skus = '';
        for (let i = 0; i < 20 && products[i]; i += 1) {
            skus += `${products[i].skuId}|`;
        }
        return encodeURIComponent(skus.slice(0, -1));
    }

    getOrganicProducts() {
        const { products } = this.state;
        const obj = {};
        for (let i = 0; i < products.length; i += 1) {
            obj[products[i].ppId] = true;
        }
        return obj;
    }

    getSortVal() {
        const { sortOptions } = this.state;
        let sortVal = 'default';
        sortOptions.forEach((item) => {
            if (item.selected && item.key) {
                switch (item.key) {
                    case 'RHL':
                        sortVal = 'rating_desc';
                        break;
                    case 'RLH':
                        sortVal = 'rating_asc';
                        break;
                    case 'PHL':
                        sortVal = 'price_desc';
                        break;
                    case 'PLH':
                        sortVal = 'price_asc';
                        break;
                    default:
                        sortVal = 'other_desc';
                        break;
                }
            }
        });
        return sortVal;
    }

    getPathName(page) {
        const { deviceType } = this.props;
        let path = '?key=804&';
        if (page === 'gallery') {
            path += `page-id=${getCriteoPageID(page, deviceType)}&`;
            path += `category=${this.getCategory()}&`;
        } else if (page === 'search') {
            path += `page-id=${getCriteoPageID(page, deviceType)}&`;
            path += `keyword=${this.getKeyword()}&`;
        }
        path += `filters=${this.getFilters()}&`;
        path += `organic-skus=${this.getOrganicSkus()}&`;
        path += `list-size=${getProductsPerPage(this.props.preferences)}&`;
        path += `page-num=${this.getPageNum()}&`;
        path += `sort=${this.getSortVal()}`;
        return path;
    }

    render() {
        // temporary hidden see, so used only to make a call for criteo products (MNPYGD-2248)
        // <div className="hooklogicrec" id="hl_1" data-whoami="criteoZone" >
        // const { criteoProducts } = this.state;
        // if (criteoProducts !== null) {
        //     return (<div id="hl_1" data-whoami="criteoZone" >
        //         <YodaProductCartridge
        //             automationId="test-automation-gallery-cretio-zone"
        //             slotId="cretio_zone"
        //             cartridgeHeader="Sponsored Items"
        //             productCartridgeList={criteoProducts}
        //             onPaneRender={this.fireBeacons}
        //             onPaneClick={this.fireClickBeacon}
        //         />
        //     </div>);
        // }
        return null;
    }
}

export const mapStateToProps = (store) => ({
    breadCrumbInfo: getBreadCrumbInfo(store),
    h1Tag: getH1Tag(store),
    pagination: store.pagination.pagination,
    products: store.products,
    sortOptions: store.sortOptions ? store.sortOptions.sortOptions : [],
    selectedFilters: store.selectedFilters,
    criteoProducts: store.criteoProducts,
    deviceType: store.context.deviceType,
    featureFlags: store.context.featureFlags,
    preferences: store.context ? store.context.preferences : {},
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getProductListFromCriteo,
            mergeSponsoredAndORganicProducts,
        },
        dispatch
    ),
});

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(CriteoZone);
